<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="PRAZOS" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/ata.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/prazos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="form-row">
        <div class="col-sm-8 form-group">
          <label for="prazo">Prazo:<span class="text-danger">*</span></label>
          <textarea id="prazo" style="height: 71px;" formControlName="nome" class="form-control"></textarea>
        </div>
        <div class="col-md-4 col-lg-4 col-xl-4">
          <div class="form-row pl-3 mt-2">
            <div class="col-sm-11 offset-1">
              <div class="card">
                <ul class="list-group list-group-flush">
                  <li class="list-group-item pl-3 pr-3 checkbox checbox-switch switch-primary">
                    <label style=" margin: 0; text-align: left;">
                      <input type="checkbox" formControlName="entrega" /><span></span>Entrega
                    </label>
                  </li>
                  <li class="list-group-item pl-3 pr-3 checkbox checbox-switch switch-primary">
                    <label style=" margin: 0; text-align: left;">
                      <input type="checkbox" formControlName="pagamento" /><span></span>Pagamento
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-2 mb-4" />
      <div class="row">
        <div class="col-12">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>